import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ErrorBoundary } from './components/ErrorBoundary';
import { ProtectedRoute } from './components/ProtectedRoute';
import { InstallPrompt } from './components/InstallPrompt';
import { LaunchHandlerBridge } from './components/LaunchHandlerBridge';
import { PhoneAppShell } from './components/PhoneAppShell';
import { CustomerProvider } from './contexts/CustomerContext';
import { LoginPage } from './pages/LoginPage';
import { VerifyPage } from './pages/VerifyPage';
import { SmsVerifyPage } from './pages/SmsVerifyPage';
import { DashboardPage } from './pages/DashboardPage';
import { BonusSummaryPage } from './pages/BonusSummaryPage';
import './App.css';

const routerBasename =
  process.env.PUBLIC_URL && process.env.PUBLIC_URL !== '/'
    ? process.env.PUBLIC_URL.replace(/\/$/, '')
    : undefined;

const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <BrowserRouter basename={routerBasename}>
        <LaunchHandlerBridge />
        <CustomerProvider>
          <PhoneAppShell>
            <Routes>
              {/* Public routes */}
              <Route path="/login" element={<LoginPage />} />
              <Route path="/verify" element={<VerifyPage />} />
              <Route path="/auth/verify-sms" element={<SmsVerifyPage />} />

              {/* Bonus Summary (public) */}
              <Route path="/bonus-summary/:id" element={<BonusSummaryPage />} />
              <Route path="/bonus-summary" element={<BonusSummaryPage />} />

              {/* Original Dashboard */}
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <DashboardPage />
                  </ProtectedRoute>
                }
              />

              {/* Operations Portal routes */}
              {/* <Route
              path="/ops"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <OpsDashboardPage />
                  </MainLayout>
                </ProtectedRoute>
              }
            /> */}
            {/* <Route
              path="/ops/sopralluogo"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <SopralluogoPage />
                  </MainLayout>
                </ProtectedRoute>
              }
            /> */}
            {/* <Route
              path="/ops/installazione"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <InstallazionePage />
                  </MainLayout>
                </ProtectedRoute>
              }
            /> */}
            {/* <Route
              path="/ops/supporto"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <SupportoPage />
                  </MainLayout>
                </ProtectedRoute>
              }
            /> */}
            {/* <Route
              path="/ops/bonus"
              element={
                // <ProtectedRoute>
                <MainLayout>
                  <BonusOpsPage />
                </MainLayout>
                // </ProtectedRoute>
              }
            /> */}

              {/* Default redirect */}
              <Route path="/" element={<Navigate to="/login" replace />} />
            </Routes>
          </PhoneAppShell>
        </CustomerProvider>
        <InstallPrompt />
      </BrowserRouter>
    </ErrorBoundary>
  );
};

export default App;

